import { render, staticRenderFns } from "./GiftVendorForm.vue?vue&type=template&id=3405d6e2&"
import script from "./GiftVendorForm.vue?vue&type=script&lang=js&"
export * from "./GiftVendorForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3405d6e2')) {
      api.createRecord('3405d6e2', component.options)
    } else {
      api.reload('3405d6e2', component.options)
    }
    module.hot.accept("./GiftVendorForm.vue?vue&type=template&id=3405d6e2&", function () {
      api.rerender('3405d6e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gift/orderMgt/modules/GiftVendorForm.vue"
export default component.exports